import { StatsigClient } from '@statsig/js-client';
import { getCookie } from './cookiesUtils';
import { isDevEnvironment } from './env';

/* In here we store the Google Optimize global variables which are the parameters
   for the A/B testing
*/

// the window variable is to be defined.

export const TESTS_DICTIONARY = {
  optimizelyI4Iframe: 'optimizelyI4Iframe', // Added by story 62253(PR#16070), to be cleaned up by story ?????
  optimizelyOfferCallout: 'optimizelyOfferCallout', // Added by story 85776(PR#23548), to be cleaned up by story xxxxx
  optimizelyUFF: 'optimizelyUFF', // Added by story 89247(PR#25012), to be cleaned up by story 90202
  optimizelyFFMEExpediaCarousel: 'optimizelyFFMEExpediaCarousel' // Added by story 91079(PR#?????), to be cleaned up by story 91383
};

export const STATSIG_TESTS = {
  planWithAI: { name: 'plan-with-ai', parameter: 'showAiPlanner' } // Added by story 92347(PR#26052), to be cleaned up by story xxxxx
};

const STABLE_ID_COOKIE = 'cf-did';
const FORCED_ARM_COOKIE = 'gwl_arm';
const FORCED_ARM_VALUES = { control: false, test: true, treatment: true };
const INITIALIZE_TIMEOUT_MS = 3000;

let statsigClient = null;
let statsigReady = null;
let statsigLodgeCode = null;

export const initStatsigExperiments = lodgeCode => {
  if (statsigReady && statsigLodgeCode === lodgeCode) return statsigReady;

  const clientKey = process.env.REACT_APP_STATSIG_CLIENT_KEY;
  const stableID = getCookie(STABLE_ID_COOKIE);

  if (!clientKey || !stableID || !lodgeCode) return (statsigReady = Promise.resolve());

  statsigLodgeCode = lodgeCode;

  const statsigUser = { customIDs: { stableID }, custom: { lodgeCode } };

  const resolve = async () => {
    const client =
      statsigClient ??
      new StatsigClient(clientKey, statsigUser, {
        environment: { tier: 'production' },
        includeCurrentPageUrlWithEvents: false
      });

    const { success } = statsigClient
      ? await client.updateUserAsync(statsigUser, { timeoutMs: INITIALIZE_TIMEOUT_MS })
      : await client.initializeAsync({ timeoutMs: INITIALIZE_TIMEOUT_MS });

    statsigClient = success ? client : null;
  };

  const timeout = new Promise(settle => setTimeout(settle, INITIALIZE_TIMEOUT_MS));

  statsigReady = Promise.race([resolve(), timeout]).catch(error => {
    console.warn('[Statsig] Experiments unavailable, falling back to the default experience.', error);
  });

  return statsigReady;
};

const readForcedArmCookie = () => {
  // getCookie decodes every cookie on the domain, so one malformed % sequence would throw during render.
  try {
    return getCookie(FORCED_ARM_COOKIE);
  } catch {
    return '';
  }
};

const getForcedArm = experimentName => {
  const cookie = readForcedArmCookie();

  if (!cookie) return undefined;

  const tokens = cookie.split(',').map(token => token.trim());
  const namedToken = tokens.find(token => token.startsWith(`${experimentName}:`));
  const arm = namedToken
    ? namedToken.slice(experimentName.length + 1).trim()
    : tokens.find(token => token && !token.includes(':'));

  return arm?.toLowerCase();
};

const getStatsigTestValue = test => {
  const forcedArm = getForcedArm(test.name);

  // Reading the experiment logs an exposure, and a forced holder was never randomised into it.
  if (Object.prototype.hasOwnProperty.call(FORCED_ARM_VALUES, forcedArm)) return FORCED_ARM_VALUES[forcedArm];

  if (!statsigClient) return null;

  const value = statsigClient.getExperiment(test.name).get(test.parameter, null);

  return typeof value === 'boolean' ? value : null;
};

/**
 * This is for tests that are located on multiple pages or components.
 * This array is to be empty by default.
 */
const MULTIPLE_TESTS_ACTIVE_LISTS = [];

/**
 * @param {string|Object} test A TESTS_DICTIONARY entry, read off the Optimizely global, or a
 * STATSIG_TESTS entry, read off the Statsig client initialised before render.
 * @param {boolean} developMode Set true to force the test on while developing.
 *
 * A Statsig test answers `null` when it could not be consulted at all - no key, no cf-did,
 * unreachable, or the guest is outside its audience - which callers must not treat as control.
 */
export const getTestValueAB = (test, developMode = false) => {
  if (developMode) {
    return true;
  }
  if (typeof test === 'object') {
    return getStatsigTestValue(test);
  }
  if (isDevEnvironment && MULTIPLE_TESTS_ACTIVE_LISTS.includes(test)) {
    return true;
  }

  return window[test] || false;
};
